module.exports = __webpack_public_path__ + "static/img/54.a48ce32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/54.png
// module id = q5Te
// module chunks = 0